<div style="min-height: 100vh;position: relative;" id="main"> 
    <router-outlet></router-outlet>
</div>
